import { atom } from 'recoil';

export const scansAgentsAtom = atom({
  key: 'scansAgentsAtom', 
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});